module.exports = __webpack_public_path__ + "static/rml-a9d5d7d1f9a696a4a67c9e84a3d2f70b.png";